<template>
  <FourZeroFour />
</template>

<script lang="ts" setup>
  import { FourZeroFour } from '@prefecthq/prefect-ui-library'
  import { usePageTitle } from '@/compositions/usePageTitle'
  usePageTitle('Page Not Found')
</script>